import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./sidebar.scss";
import "react-loading-skeleton/dist/skeleton.css";

const Sidebar = () => {
  const location = useLocation();

  return (
    <div className='nav-bar'>
      <nav className='nav flex-column'>
        <ul>
          <li>
            <Link
              to='/legalDoc'
              className={`${location.pathname === "/legalDoc" ? "active" : ""}`}
            >
              Legal Documents
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
